import { supabase } from '$lib/supabase';
import { writable } from 'svelte/store';
import { newLiveChannel } from '$lib/stores/liveChannelStore';


export function initializeLiveChannelSubscription() {
  console.log('LiveChannelService: Initializing subscription');

  const channel = supabase.channel('public:channels');

  channel
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'channels',
      },
      (payload) => {
        console.log('LiveChannelService: Received update', payload);
        if (payload.new.is_live) {
          console.log('LiveChannelService: New live channel detected:', payload.new);
          newLiveChannel.set(payload.new as any);
        }
      }
    )
    .subscribe((status) => {
      console.log('LiveChannelService: Subscription status:', status);
    });

  console.log('LiveChannelService: Subscription initialized');

  return () => {
    console.log('LiveChannelService: Unsubscribing');
    supabase.removeChannel(channel);
  };
}

export async function testLiveChannelUpdate(channelId: string) {
  console.log('Testing live channel update for channel:', channelId);
  try {
    const { data, error } = await supabase
      .from('channels')
      .update({ is_live: true })
      .eq('id', channelId)
      .select();

    if (error) throw error;
    console.log('Channel updated:', data);
  } catch (error) {
    console.error('Error updating channel:', error);
  }
}